const MyQR = ({ color }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="92" height="92" fill="none" />
      <path
        d="M5 78.2143C5 83.0647 8.93527 87 13.7857 87L31.3571 87C36.2076 87 40.1429 83.0647 40.1429 78.2143L40.1429 60.6429C40.1429 55.7924 36.2076 51.8571 31.3571 51.8571L13.7857 51.8571C8.93526 51.8571 5 55.7924 5 60.6429L5 78.2143ZM16.7143 75.2857L16.7143 63.5714L28.4286 63.5714L28.4286 75.2857L16.7143 75.2857ZM5 31.3571C5 36.2076 8.93526 40.1429 13.7857 40.1429L31.3571 40.1429C36.2076 40.1429 40.1429 36.2076 40.1428 31.3571L40.1428 13.7857C40.1428 8.93527 36.2076 5 31.3571 5L13.7857 5C8.93526 5.00001 4.99999 8.93527 4.99999 13.7857L5 31.3571ZM16.7143 28.4286L16.7143 16.7143L28.4286 16.7143L28.4286 28.4286L16.7143 28.4286ZM60.6429 87L78.2143 87C83.0647 87 87 83.0647 87 78.2143L87 60.6429C87 55.7924 83.0647 51.8571 78.2143 51.8571L60.6429 51.8571C55.7924 51.8571 51.8571 55.7924 51.8571 60.6429L51.8571 78.2143C51.8571 83.0647 55.7924 87 60.6429 87ZM75.2857 75.2857L63.5714 75.2857L63.5714 63.5714L75.2857 63.5714L75.2857 75.2857ZM51.8571 37.2143C51.8571 38.825 53.175 40.1429 54.7857 40.1429L66.5 40.1429C68.1107 40.1429 69.4286 38.825 69.4286 37.2143C69.4286 35.6036 70.7464 34.2857 72.3571 34.2857L78.2143 34.2857C79.825 34.2857 81.1428 35.6036 81.1428 37.2143C81.1428 38.825 82.4607 40.1429 84.0714 40.1429C85.6821 40.1429 87 38.825 87 37.2143L87 19.6429C87 18.0321 85.6821 16.7143 84.0714 16.7143L72.3571 16.7143C70.7464 16.7143 69.4286 18.0321 69.4286 19.6429C69.4286 21.2536 68.1107 22.5714 66.5 22.5714C64.8893 22.5714 63.5714 21.2536 63.5714 19.6429L63.5714 7.92857C63.5714 6.31786 62.2536 5 60.6428 5L54.7857 5C53.175 5 51.8571 6.31786 51.8571 7.92857L51.8571 37.2143ZM72.3571 5C71.5804 5 70.8355 5.30854 70.2863 5.85776C69.7371 6.40697 69.4286 7.15187 69.4286 7.92857C69.4286 8.70528 69.7371 9.45017 70.2863 9.99939C70.8355 10.5486 71.5804 10.8571 72.3571 10.8571C73.1338 10.8571 73.8787 10.5486 74.4279 9.99939C74.9772 9.45017 75.2857 8.70528 75.2857 7.92857C75.2857 7.15187 74.9772 6.40697 74.4279 5.85776C73.8787 5.30854 73.1338 5 72.3571 5ZM84.0714 5C83.2947 5 82.5498 5.30854 82.0006 5.85776C81.4514 6.40697 81.1428 7.15186 81.1428 7.92857C81.1428 8.70528 81.4514 9.45017 82.0006 9.99939C82.5498 10.5486 83.2947 10.8571 84.0714 10.8571C84.8481 10.8571 85.593 10.5486 86.1422 9.99938C86.6914 9.45017 87 8.70528 87 7.92857C87 7.15186 86.6914 6.40697 86.1422 5.85776C85.593 5.30854 84.8481 5 84.0714 5Z"
        fill={color}
      />
    </svg>
  );
};

const Analys = ({ color }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_537_1190)">
        <rect width="92" height="92" />
        <path
          d="M14.5858 63.5858L8 57C7.44772 56.4477 7.44772 55.5523 8 55L31.5858 31.4142C32.3668 30.6332 33.6332 30.6332 34.4142 31.4142L43.0858 40.0858C43.8668 40.8668 45.1332 40.8668 45.9142 40.0858L62.0858 23.9142C62.8668 23.1332 62.8668 21.8668 62.0858 21.0858L56.4142 15.4142C55.1543 14.1543 56.0466 12 57.8284 12H80C81.1046 12 82 12.8954 82 14V36.1716C82 37.9534 79.8457 38.8457 78.5858 37.5858L73.9142 32.9142C73.1332 32.1332 71.8668 32.1332 71.0858 32.9142L45.9142 58.0858C45.1332 58.8668 43.8668 58.8668 43.0858 58.0858L34.4142 49.4142C33.6332 48.6332 32.3668 48.6332 31.5858 49.4142L17.4142 63.5858C16.6332 64.3668 15.3668 64.3668 14.5858 63.5858Z"
          fill={color}
        />
        <path
          d="M9 87.5V66C15.4 75.6 25.3333 66.3333 29.5 60.5V87.5H9Z"
          fill={color}
        />
        <path
          d="M35 87.5V58C41.4 67.6 51.3333 63.8333 55.5 58V87.5H35Z"
          fill={color}
        />
        <path
          d="M62 87.5V50.5L72.5 39C72.5 39 76 45 82.5 43.5V87.5H62Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_537_1190">
          <rect width="92" height="92" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const DashboardSVG = ({ color }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0065874 11.9766C0.0065874 12.8203 0.683671 13.4813 1.45103 13.4813H2.89548L2.86388 20.9906C2.86388 21.1172 2.87291 21.2437 2.88645 21.3703V22.125C2.88645 23.1609 3.69443 24 4.692 24H5.41423C5.46388 24 5.51353 24 5.56318 23.9953C5.62638 24 5.68957 24 5.75277 24H7.21978H8.30311C9.30068 24 10.1087 23.1609 10.1087 22.125V21V18C10.1087 17.1703 10.7542 16.5 11.5531 16.5H14.442C15.241 16.5 15.8864 17.1703 15.8864 18V21V22.125C15.8864 23.1609 16.6944 24 17.692 24H18.7753H20.2153C20.283 24 20.3507 23.9953 20.4184 23.9906C20.4726 23.9953 20.5267 24 20.5809 24H21.3031C22.3007 24 23.1087 23.1609 23.1087 22.125V16.875C23.1087 16.8328 23.1087 16.7859 23.1042 16.7438V13.4813H24.5531C25.3656 13.4813 25.9976 12.825 25.9976 11.9766C25.9976 11.5547 25.8621 11.1797 25.5462 10.8516L13.9726 0.375C13.6566 0.046875 13.2955 0 12.9795 0C12.6635 0 12.3024 0.09375 12.0316 0.328125L0.503115 10.8516C0.142004 11.1797 -0.0385515 11.5547 0.0065874 11.9766Z"
        fill={color}
      />
    </svg>
  );
};

const ProfileSVG = ({ color }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="92" height="92" fill="none" />
      <path
        d="M45.875 46.1429C51.3309 46.1429 56.5633 43.9755 60.4212 40.1176C64.2791 36.2597 66.4464 31.0273 66.4464 25.5714C66.4464 20.1155 64.2791 14.8831 60.4212 11.0252C56.5633 7.16734 51.3309 5 45.875 5C40.4191 5 35.1867 7.16734 31.3288 11.0252C27.4709 14.8831 25.3036 20.1155 25.3036 25.5714C25.3036 31.0273 27.4709 36.2597 31.3288 40.1176C35.1867 43.9755 40.4191 46.1429 45.875 46.1429ZM38.5304 53.8571C22.7 53.8571 9.875 66.6821 9.875 82.5125C9.875 85.1482 12.0125 87.2857 14.6482 87.2857H77.1018C79.7375 87.2857 81.875 85.1482 81.875 82.5125C81.875 66.6821 69.05 53.8571 53.2196 53.8571H38.5304Z"
        fill={color}
      />
    </svg>
  );
};

const CreateQRSVG = ({ color }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="92" height="92" fill="none" />
      <path
        d="M4.50293 33.8491C4.50293 26.7062 10.2936 20.9155 17.4365 20.9155H33.8974C35.8521 20.9155 37.4247 22.4881 37.4247 24.4429C37.4247 26.3976 35.8521 27.9702 33.8974 27.9702H17.4365C14.1884 27.9702 11.5576 30.601 11.5576 33.8491V73.8256C11.5576 77.0737 14.1884 79.7045 17.4365 79.7045H57.413C60.6611 79.7045 63.2919 77.0737 63.2919 73.8256V57.3647C63.2919 55.4099 64.8645 53.8373 66.8192 53.8373C68.7739 53.8373 70.3465 55.4099 70.3465 57.3647V73.8256C70.3465 80.9684 64.5558 86.7591 57.413 86.7591H17.4365C10.2936 86.7591 4.50293 80.9684 4.50293 73.8256V33.8491Z"
        fill={color}
      />
      <path
        d="M15.084 35.3191C15.084 32.6414 17.2423 30.469 19.9026 30.469H29.5398C32.2 30.469 34.3584 32.6414 34.3584 35.3191V45.0193C34.3584 47.6969 32.2 49.8694 29.5398 49.8694H19.9026C17.2423 49.8694 15.084 47.6969 15.084 45.0193V35.3191ZM21.5088 36.9358V43.4026H27.9336V36.9358H21.5088ZM15.084 61.1862C15.084 58.5086 17.2423 56.3361 19.9026 56.3361H29.5398C32.2 56.3361 34.3584 58.5086 34.3584 61.1862V70.8864C34.3584 73.5641 32.2 75.7365 29.5398 75.7365H19.9026C17.2423 75.7365 15.084 73.5641 15.084 70.8864V61.1862ZM21.5088 62.8029V69.2697H27.9336V62.8029H21.5088ZM40.7832 57.9528C40.7832 57.0637 41.5059 56.3361 42.3893 56.3361H48.8141C49.6975 56.3361 50.4203 57.0637 50.4203 57.9528C50.4203 58.842 51.1431 59.5695 52.0265 59.5695H55.2389C56.1223 59.5695 56.8451 58.842 56.8451 57.9528C56.8451 57.0637 57.5679 56.3361 58.4513 56.3361C59.3347 56.3361 60.0575 57.0637 60.0575 57.9528V67.653C60.0575 68.5422 59.3347 69.2697 58.4513 69.2697H52.0265C51.1431 69.2697 50.4203 68.5422 50.4203 67.653C50.4203 66.7638 49.6975 66.0363 48.8141 66.0363C47.9307 66.0363 47.2079 66.7638 47.2079 67.653V74.1198C47.2079 75.009 46.4852 75.7365 45.6017 75.7365H42.3893C41.5059 75.7365 40.7832 75.009 40.7832 74.1198V57.9528ZM52.0265 75.7365C51.6005 75.7365 51.192 75.5662 50.8908 75.263C50.5896 74.9598 50.4203 74.5486 50.4203 74.1198C50.4203 73.691 50.5896 73.2798 50.8908 72.9766C51.192 72.6734 51.6005 72.5031 52.0265 72.5031C52.4525 72.5031 52.8611 72.6734 53.1623 72.9766C53.4635 73.2798 53.6327 73.691 53.6327 74.1198C53.6327 74.5486 53.4635 74.9598 53.1623 75.263C52.8611 75.5662 52.4525 75.7365 52.0265 75.7365ZM58.4513 75.7365C58.0253 75.7365 57.6168 75.5662 57.3156 75.263C57.0144 74.9598 56.8451 74.5486 56.8451 74.1198C56.8451 73.691 57.0144 73.2798 57.3156 72.9766C57.6168 72.6734 58.0253 72.5031 58.4513 72.5031C58.8773 72.5031 59.2859 72.6734 59.5871 72.9766C59.8883 73.2798 60.0575 73.691 60.0575 74.1198C60.0575 74.5486 59.8883 74.9598 59.5871 75.263C59.2859 75.5662 58.8773 75.7365 58.4513 75.7365Z"
        fill={color}
      />
      <path
        d="M55.24 30.469H45.6028C42.9425 30.469 40.7842 32.6414 40.7842 35.3191V45.0193L55.24 30.469Z"
        fill={color}
      />
      <path
        d="M78.142 13.7103L79.9203 15.4887C81.3019 16.8702 81.3019 19.1042 79.9203 20.471L75.6434 24.7626L68.868 17.9872L73.1449 13.7103C74.5264 12.3288 76.7604 12.3288 78.1273 13.7103H78.142ZM44.1619 42.7079L63.8856 22.9696L70.6611 29.745L50.9227 49.4687C50.4965 49.8949 49.9674 50.2035 49.3942 50.3652L40.7963 52.8196L43.2507 44.2218C43.4124 43.6486 43.721 43.1195 44.1472 42.6932L44.1619 42.7079ZM68.1625 8.72794L39.1649 37.7109C37.8862 38.9895 36.9603 40.5621 36.4753 42.2817L32.2719 56.979C31.9191 58.2135 32.2572 59.5363 33.1684 60.4475C34.0796 61.3587 35.4024 61.6968 36.637 61.344L51.3342 57.1406C53.0685 56.6409 54.6411 55.715 55.905 54.451L84.9027 25.4681C89.0326 21.3382 89.0326 14.6362 84.9027 10.5063L83.1243 8.72794C78.9944 4.59801 72.2925 4.59801 68.1625 8.72794Z"
        fill={color}
      />
    </svg>
  );
};

const OrgSVG = ({ color }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_690_228)">
        <path
          d="M46 46C50.2435 46 54.3131 44.3143 57.3137 41.3137C60.3143 38.3131 62 34.2435 62 30C62 25.7565 60.3143 21.6869 57.3137 18.6863C54.3131 15.6857 50.2435 14 46 14C41.7565 14 37.6869 15.6857 34.6863 18.6863C31.6857 21.6869 30 25.7565 30 30C30 34.2435 31.6857 38.3131 34.6863 41.3137C37.6869 44.3143 41.7565 46 46 46ZM40.2875 52C27.975 52 18 61.975 18 74.2875C18 76.3375 19.6625 78 21.7125 78H70.2875C72.3375 78 74 76.3375 74 74.2875C74 61.975 64.025 52 51.7125 52H40.2875Z"
          fill={color}
        />
        <path
          d="M19 46C21.8795 46 24.641 44.8411 26.6772 42.7782C28.7133 40.7153 29.8571 37.9174 29.8571 35C29.8571 32.0826 28.7133 29.2847 26.6772 27.2218C24.641 25.1589 21.8795 24 19 24C16.1205 24 13.359 25.1589 11.3228 27.2218C9.28673 29.2847 8.14287 32.0826 8.14287 35C8.14287 37.9174 9.28673 40.7153 11.3228 42.7782C13.359 44.8411 16.1205 46 19 46ZM15.1237 50.125C6.76875 50.125 0 56.9828 0 65.4477C0 66.857 1.12813 68 2.51919 68H35.4808C36.8719 68 38 66.857 38 65.4477C38 56.9828 31.2313 50.125 22.8763 50.125H15.1237Z"
          fill={color}
        />
        <path
          d="M73 46C75.8795 46 78.641 44.8411 80.6772 42.7782C82.7133 40.7153 83.8571 37.9174 83.8571 35C83.8571 32.0826 82.7133 29.2847 80.6772 27.2218C78.641 25.1589 75.8795 24 73 24C70.1205 24 67.359 25.1589 65.3228 27.2218C63.2867 29.2847 62.1429 32.0826 62.1429 35C62.1429 37.9174 63.2867 40.7153 65.3228 42.7782C67.359 44.8411 70.1205 46 73 46ZM69.1237 50.125C60.7687 50.125 54 56.9828 54 65.4477C54 66.857 55.1281 68 56.5192 68H89.4808C90.8719 68 92 66.857 92 65.4477C92 56.9828 85.2313 50.125 76.8763 50.125H69.1237Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_690_228">
          <rect width="92" height="92" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { CreateQRSVG, DashboardSVG, ProfileSVG, MyQR, Analys, OrgSVG };
